import { Box, CardMedia } from "@mui/material";
import IllustrationErrorPage from "assets/illustrations/error_page.svg";

export default function GlobalErrorPage() {
  return (
    <Box
      sx={{
        padding: 20,
        boxSizing:'border-box',
        width:'100vw',
        height:'100vh',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor:"#404040"
      }}
    >
      <CardMedia
        component="img"
        sx={{ maxWidth: 800 }}
        src={IllustrationErrorPage}
      />
    </Box>
  );
}
